/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TChatsBulkOperationsRestoreFromArchiveDesktopModel,
  IChatsBulkOperationsRestoreFromArchiveDesktopRequest,
  IMappers,
  IChatsBulkOperationsRestoreFromArchiveDesktopResponse,
  IChatsBulkOperationsRestoreFromArchiveDesktopResponseError,
  TChatsBulkOperationsRestoreFromArchiveDesktopResponse,
} from './types';

const defaultConfig: TChatsBulkOperationsRestoreFromArchiveDesktopModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'chats',
  pathApi: '/v1/chats/bulk-operations/restore-from-archive-desktop/',
  hostType: 'api',
} as TChatsBulkOperationsRestoreFromArchiveDesktopModel;

function createChatsBulkOperationsRestoreFromArchiveDesktopModel(
  parameters: IChatsBulkOperationsRestoreFromArchiveDesktopRequest,
): TChatsBulkOperationsRestoreFromArchiveDesktopModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IChatsBulkOperationsRestoreFromArchiveDesktopOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IChatsBulkOperationsRestoreFromArchiveDesktopRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchChatsBulkOperationsRestoreFromArchiveDesktop<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IChatsBulkOperationsRestoreFromArchiveDesktopOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TChatsBulkOperationsRestoreFromArchiveDesktopResponse
> {
  const { response, statusCode } = await httpApi.fetch(
    createChatsBulkOperationsRestoreFromArchiveDesktopModel(parameters),
    config,
  );

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IChatsBulkOperationsRestoreFromArchiveDesktopResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IChatsBulkOperationsRestoreFromArchiveDesktopResponseError);
    }
  }

  return { response, statusCode } as TChatsBulkOperationsRestoreFromArchiveDesktopResponse;
}

export {
  defaultConfig,
  createChatsBulkOperationsRestoreFromArchiveDesktopModel,
  fetchChatsBulkOperationsRestoreFromArchiveDesktop,
};
